// extracted by mini-css-extract-plugin
export default {"InfoPage":"InfoPage_InfoPage__LcgII","Rule":"InfoPage_Rule__Fr-Bh","Paragraph":"InfoPage_Paragraph__1hIsC"};